module.exports = __webpack_public_path__ + "fonts/GolosText-VariableFont_wght.cddbe8e.ttf";